import { mirrorColor } from "@corca/tiptap";

import { twMerge } from "@/utils/twMerge";

import type { Color } from "@corca/data";

export function getMixedBackgroundClassNames(colors: Color[], gradientClassName?: string) {
  if (colors.length === 0) {
    return "";
  }

  const [from, ...rest] = colors;
  const to = rest.pop();

  if (!to) {
    return `bg-${from} dark:bg-${mirrorColor(from)}`;
  }

  const viaColor =
    rest.length > 0
      ? rest.map((color) => `via-${color} dark:via-${mirrorColor(color)}`).join(" ")
      : "";

  return twMerge(
    `from-${from} dark:from-${mirrorColor(from)}`,
    `to-${to} dark:to-${mirrorColor(to)}`,
    viaColor,
    gradientClassName,
  );
}
